import { Injectable } from '@angular/core';
import { BreadcrumbMeta, ContentPageMetaResolver, Page } from '@spartacus/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class OspPageMetaResolver extends ContentPageMetaResolver {
  pageTemplate = 'sanofiOnlineSupportPageTemplate';

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[]> {
    let breadcrumbs: Observable<BreadcrumbMeta[]> = of([]);
    breadcrumbs = of([
      { label: 'Home', link: '/' },
      { label: 'Tools & Resources', link: '/toolsandresources' },
      { label: 'Help Center', link: '' },
    ]);
    return breadcrumbs;
  }

  getScore(page: Page): number {
    let score = 0;
    if (this.pageTemplate) {
      score += page.template === this.pageTemplate ? 100 : -1;
    }
    return score;
  }
}
